import { StepName } from '@/components/general/FeedbackPopup/FeedbackPopup';
import { atom, useRecoilState } from 'recoil';

const formStepState = atom<StepName>({
    key: 'formStepState',
    default: 'connect',
});

export const useFormStepState = () => useRecoilState(formStepState);
